var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBondex(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 39,
    viewBox: "0 0 138 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6586 15.3113C41.5649 15.3113 39.9779 16.0646 39.1413 16.9954V9.63611H36.7773V29.3859H39.004L39.0931 27.8744C40.0627 28.9331 41.6576 29.5067 43.6824 29.5067C45.7071 29.5067 47.3947 28.9252 48.4168 27.8269C49.6846 26.4743 50.2754 24.7148 50.2754 22.289C50.2754 20.0084 49.7148 18.2992 48.5612 17.0629C47.4422 15.8677 45.8846 15.3113 43.6586 15.3113ZM43.4423 17.5309C45.1399 17.5309 46.2339 17.9564 46.9879 18.9101C47.6103 19.7036 47.8878 20.7825 47.8878 22.409C47.8878 24.1786 47.5607 25.3616 46.8578 26.1322L46.8549 26.135C46.1325 26.9472 44.9445 27.359 43.3222 27.359C40.6765 27.359 39.7084 25.9036 39.3655 25.0289C39.2189 24.5696 39.0938 24.1657 39.0938 22.7454C39.0938 21.4947 39.1585 20.9586 39.3015 20.2434C39.7386 18.494 41.2091 17.5309 43.4423 17.5309Z",
    fill: "#001026"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.767 15.3114C56.4986 15.3114 54.6464 16.0532 53.4102 17.4576C52.3026 18.7161 51.7168 20.4448 51.7168 22.4572C51.7168 26.9314 54.3525 29.6031 58.7663 29.6031C63.1801 29.6031 65.7676 26.8647 65.7676 22.4572C65.7676 18.0499 63.2169 15.3114 58.767 15.3114ZM58.767 27.3591C55.7015 27.3591 54.0815 25.6643 54.0815 22.4572C54.0815 19.2502 55.7806 17.6035 58.7426 17.6035C61.923 17.6035 63.4044 19.1459 63.4044 22.4572C63.4044 25.7686 61.7577 27.3591 58.767 27.3591Z",
    fill: "#001026"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8781 20.0515C79.8781 23.7193 79.8939 27.1687 79.9104 29.3867H77.4717C77.466 27.1873 77.466 23.4915 77.466 20.3643C77.466 18.4969 76.4138 17.6272 74.1518 17.6272C71.4465 17.6272 70.2354 19.1589 70.2354 20.6769V29.3867H67.8477V15.5752H70.1642V16.8667C71.3228 15.5357 73.4496 15.3107 74.7541 15.3107C77.9634 15.3107 79.8796 17.0831 79.8796 20.0515H79.8781Z",
    fill: "#001026"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1739 27.7717V9.75623H92.81V16.8639C91.9094 15.9339 90.3699 15.3833 88.5572 15.3833C84.4014 15.3833 81.8203 18.1304 81.8203 22.5529C81.8203 26.9753 84.042 29.6023 88.0763 29.6023C89.3708 29.6023 91.5695 29.3666 92.8474 27.9176L93.0084 29.3853H95.2746L95.2444 29.0655C95.2444 29.0576 95.1733 28.3028 95.1733 27.7703L95.1739 27.7717ZM88.4616 27.4792C85.6002 27.4792 84.2087 25.8598 84.2087 22.5292C84.2087 19.3695 85.6958 17.6992 88.5098 17.6992C90.022 17.6992 91.0462 18.0341 91.7341 18.7542C92.4744 19.529 92.8345 20.7876 92.8345 22.601C92.8345 25.9288 91.4451 27.4792 88.4616 27.4792Z",
    fill: "#001026"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.37 24.7615H108.007L107.98 25.0239C107.904 25.7477 107.346 27.431 103.798 27.431C100.931 27.431 99.3854 26.107 99.1994 23.4944H110.401L110.414 23.2162C110.543 20.5022 109.963 18.4502 108.69 17.1162C107.548 15.9188 105.854 15.3114 103.653 15.3114C101.571 15.3114 99.847 15.9425 98.669 17.1357C97.442 18.3783 96.8203 20.1609 96.8203 22.4328C96.8203 27.1902 99.1599 29.6031 103.774 29.6031C109.015 29.6031 110.094 26.4549 110.315 25.1015L110.37 24.7615ZM103.653 17.531C106.475 17.531 107.899 18.788 107.997 21.3713H99.1915C99.2669 19.8151 100.001 17.531 103.653 17.531Z",
    fill: "#001026"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.766 22.3163L124.451 15.5759H121.666L117.409 20.6015L113.43 15.5759H110.487L116.011 22.3818L110.111 29.3867H112.872L117.325 24.0945L121.614 29.3867H124.507L118.766 22.3163Z",
    fill: "#001026"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.411 10.4204V13.3471H126.611V10.4204H125.443V9.75696H128.583V10.4204H127.411Z",
    fill: "#001026"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M132.026 13.3471V10.9752L131.195 13.3471H130.423L129.618 10.9752V13.3471H128.887V9.75696H129.95L130.819 12.3566L131.728 9.75696H132.759V13.3471H132.026Z",
    fill: "#001026"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2429 19.6196L5.24219 19.6355V33.4872H22.945L9.08534 19.6275L5.2429 19.6196Z",
    fill: "url(#paint0_linear_2048_7026)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2429 19.6196L5.24219 19.6355V33.4872H22.945L9.08534 19.6275L5.2429 19.6196Z",
    fill: "url(#paint1_linear_2048_7026)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24.13 19.6201L16.6035 27.1465L22.9132 33.4562L30.4397 25.9298L24.13 19.6201Z",
    fill: "url(#paint2_linear_2048_7026)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9132 5.7843L16.6035 12.094L24.13 19.6204L30.4397 13.3107L22.9132 5.7843Z",
    fill: "url(#paint3_linear_2048_7026)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24219 23.4708L22.945 5.76794H5.24219V19.6197V23.4708Z",
    fill: "url(#paint4_linear_2048_7026)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2048_7026",
    x1: 14.0936,
    y1: 19.7045,
    x2: 14.0936,
    y2: 32.9798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#1A8772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#16AF91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A8772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2048_7026",
    x1: 4.88424,
    y1: 24.2786,
    x2: 12.0725,
    y2: 31.4662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#205147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#205349",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2048_7026",
    x1: 19.6101,
    y1: 30.4483,
    x2: 26.8027,
    y2: 23.2565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#205147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1D6C5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2048_7026",
    x1: 19.6949,
    y1: 8.87539,
    x2: 26.784,
    y2: 15.9644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#205147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1D6C5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2048_7026",
    x1: 14.0936,
    y1: 23.7418,
    x2: 14.0936,
    y2: 6.5327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#1A8772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#16AF91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A8772"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBondex);
export default __webpack_public_path__ + "static/media/bondex.3cf1e39af22a4a1894832acf8bacfa1a.svg";
export { ForwardRef as ReactComponent };